__turbopack_context__.v({
  "closeButton": "LayoutModal-module__f5uuqa__closeButton",
  "modal": "LayoutModal-module__f5uuqa__modal",
  "modalActions": "LayoutModal-module__f5uuqa__modalActions",
  "modalContent": "LayoutModal-module__f5uuqa__modalContent",
  "modalHeader": "LayoutModal-module__f5uuqa__modalHeader",
  "modalInner": "LayoutModal-module__f5uuqa__modalInner",
  "outerContainer": "LayoutModal-module__f5uuqa__outerContainer",
  "portalTarget": "LayoutModal-module__f5uuqa__portalTarget",
  "portalTargetInert": "LayoutModal-module__f5uuqa__portalTargetInert",
});
